@if(isParticipantFlow) {
    <ppl-invoice-consumer-list></ppl-invoice-consumer-list>
}

@else {
    <ppl-provider-invoice></ppl-provider-invoice>
}